import service from '@/store/services/cash-register-services-service';

const state = {
    list: {},
    cashRegisterService: {},
    importResult: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, cashRegisterService) => {
        state.cashRegisterService = cashRegisterService;
    },
    SET_IMPORT_RESULT: (state, result) => {
        state.importResult = result;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((cashRegisterService) => { commit('SET_RESOURCE', cashRegisterService); });
    },

    multipleAdd({ commit }, params) {
        return service.multipleAdd(params)
            .then((result) => { commit("SET_IMPORT_RESULT", result); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((cashRegisterService) => { commit('SET_RESOURCE', cashRegisterService); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    cashRegisterService: state => state.cashRegisterService,
    url: state => state.url,
    importResult: state => state.importResult,
};

const cashRegisterService = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default cashRegisterService;